import React from 'react'
import styled from 'styled-components'
import ButtonTC from '../../../../components/button-tc/button-tc';
import { ArrowIosForwardOutline } from '@styled-icons/evaicons-outline'
import ItemOption from '../item-option/item-option';
import { device } from '../../../../config/theme/breakpoints';

const GeneralCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ContainerItem = styled(GeneralCenter)`
    width: 100%;
    background: #F2F2F2;
    padding: 30px;
    margin-top: 20px;
    margin-bottom: 0px;
    flex-wrap: wrap;
    border-radius: 15px;
    align-items: flex-start;
`

const ContainerLeft = styled(GeneralCenter)`
    width: 100%;
    flex-direction: column;
    align-items: flex-start;

    > div:nth-child(2){
        margin-top: 20px;
    }

    @media ${device.tablet}{
        width: 35%;
    }
`
const ContainerRight = styled.div`
    width: 100%;
    padding-left: 0;

    @media ${device.tablet}{
        width: 65%;
        padding-left: 15px;
    }
`

const ContainerImage = styled.div`
    width: 100%;

    > img {
        width: 100%;
        max-width: 320px;
        border-radius: 10px 10px 100px 10px;
    }
`

const ContainerText = styled.div`
    > h2, h4, p{
        margin: 0;
        margin-bottom: 5px;
    }

    > h4 {
        color: ${p => p.theme.palette.secondary.main}
    }

    > h2 {
        color: ${p => p.theme.palette.primary.main}
    }

    > p {
        color: ${p => p.theme.palette.text.black};
        font-size: 13px;
        margin-top: 20px;
    }
`

const ContainerOptions = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 10px;

    @media ${device.mobileL}{
        width: 50%;
    }
`

const ContainerButton = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
`
const customStyleButton = `
    margin: inherit;
    height: 50px;
`

interface IOption {
    id: number,
    icon: string,
    name: string;
}
export interface IServiceProps{
    image: string;
    preTitle: string;
    title: string;
    to: string;
    description: string;
    listOptions: IOption[];
}

const ItemService: React.FunctionComponent<IServiceProps> = ({
    to,
    image,
    preTitle,
    title,
    description,
    listOptions = [],
}) => {
  return (
    <ContainerItem>
        <ContainerLeft>
            <ContainerImage>
                <img src={image} alt='bus' />
            </ContainerImage>
        </ContainerLeft>
        <ContainerRight>
            <ContainerText>
                <h4>{preTitle}</h4>
                <h2>{title}</h2>
                <p>{description}</p>
            </ContainerText>
            <ContainerOptions>
                {listOptions.map(option => (
                    <ItemOption key={option.id} icon={option.icon} name={option.name}/>
                ))}
            </ContainerOptions>
            <ContainerButton>
                <ButtonTC
                    text='Ver destinos ahora'
                    icon={<ArrowIosForwardOutline />}
                    buttonStyle='secondary'
                    className={customStyleButton}
                    to={to}
                />
            </ContainerButton>
        </ContainerRight>
    </ContainerItem>
  )
}

export default ItemService